module.exports = __webpack_public_path__ + "img/login1.760b1533.png";